module.exports = __webpack_public_path__ + "img/main6.b07fac6b.png";